import { Component } from '@angular/core';

@Component({
  selector: 'app-slime-background',
  templateUrl: 'slime-background.component.html',
  styleUrls: ['slime-background.component.scss'],
})
export class SlimeBackgroundComponent {}
